import { APPROVE_CHECK, FAIL_CHECK } from '../actions/actionTypes';

export const app = (state, action) => {
  const initState = {
    checkIsPending: true,
    checkPassed: false,
  };

  switch (action.type) {
    case APPROVE_CHECK:
      return { ...state, checkPassed: true, checkIsPending: false };
    case FAIL_CHECK:
      return { ...state, checkPassed: false, checkIsPending: false };
    default:
      return state || initState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js